import { render, staticRenderFns } from "./PantallaSurtirPedido.vue?vue&type=template&id=44db0310&lang=true&"
import script from "./PantallaSurtirPedido.vue?vue&type=script&lang=js&"
export * from "./PantallaSurtirPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports